import React, {useState, useEffect} from 'react'

/*
indicateur Total workload (nouvel indicateur que je vais rajouter dans defs_v2 : indF96 = indF83 / paramF6_def / 52)
(nouvel indicateur que je vais rajouter dans defs_v2 : indF97 = indAn156 / (indAn156 + indAn157))
*/
import './report.css'

import {store} from '../../stores/store'

import IndicatorsGroupsList from './IndicatorsGroups/IndicatorsGroups'

import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts'
import {COLORS} from "../../js/ids"


import AEPHistory from './AEPHistory/AEPHistory'
import IndicatorsPool from '../../js/IndicatorsPool'
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore'
import Translations from '../../js/Translations'
import AleasPool from '../../js/AleasPool'

function getPermanents() {
  return store.indicatorsTrees.permanent.map(inds => inds.id)
}

function ReportPopup() {
  let [visibleInds, setVisibleInds] = useState(getPermanents())
  let [indsTitles, setIndsTitles] = useState([])
  const [chartData, setChartData] = useState([]);

  useEffect(()=> {

    const _indTitles = {}
    visibleInds.forEach(id => {
      let ind = IndicatorsPool.getIndicator(id)
      _indTitles[id] = ind.title
    })


    setIndsTitles(_indTitles)

    const chartData = []
    var allVals = store.allIndValuesHistory // [{year1}, {year2}]

    allVals.forEach((vals, index) => {
      let curveObj = {
        year: store.t("year") + " " + index,
        index: index,
        aleas: AleasPool.aleasHistory[index]
      }
      visibleInds.forEach( id => {
        let val = vals[id]
        let title = id
        curveObj[title] = val
      })

      // on ne push pas si une valeur est undefined ?
      if(Object.values(curveObj).every(v => v !== undefined)) {
        chartData.push(curveObj)
      }
    })

    setChartData(chartData)
  }, [visibleInds]);

  function setIndicatorsChartVisibility(ids, value) {
    ids.forEach(id => {
      if (value) {
        if(visibleInds.indexOf(id) === -1) visibleInds = [...visibleInds, id]
      } else {
        visibleInds = visibleInds.filter(_id => _id !== id)
      }
    })
    setVisibleInds(visibleInds)
  }

  function customDot(data) {
    let {key, dataKey, cx, cy, r, stroke, strokeWidth, fill, height, width } = data;
    let aleas = data.payload.aleas
    if(dataKey === "indT43" && aleas.length > 0) {
      fill = "yellow"
      stroke = "black"
      r = 8
    }
    return <circle
    key={key}
    r={r}
    stroke={stroke}
    strokeWidth={strokeWidth}
    fill={fill}
    width={width}
    height={height}
    cx={cx} cy={cy} />
  }

  function generateTtipContent(data) {
    return (
      <div className="ttip">

        <div className="ttip-title">{data.label}</div>

        {data.payload.map(p => (
          <div
          className="data"
          key={p.dataKey}
          style={{color: p.color}}
          dangerouslySetInnerHTML={{__html: p.name + data.separator + p.value + (p.unit || "")}} />

        ))}

        {data.active && data.payload[0].payload.aleas.length > 0 &&
        <div className="aleas-title" dangerouslySetInnerHTML={{__html: store.t("tooltip_aleas_title")}} />}

        {data.active && data.payload[0].payload.aleas.map(alea_id => {
          let title = AleasPool.get(alea_id).translated_name
          return <div key={alea_id} className="alea-name" dangerouslySetInnerHTML={{__html: title}} />
        })}
      </div>
    )
  }


  return (
  <>
    <div className="overlay" onClick={() => PopupStore.toggle(POPUPS_IDS.REPORT)} />
    <div className="report-window">
      {store.yearNumber === 1 &&
      <div className="report-window-title">{store.t("report_popup_title_year_1")}</div>}

      {store.yearNumber > 1 &&
      <div className="report-window-title">{store.t("report_popup_title_year_2+")} {store.yearNumber - 1}</div>}

      <div className="report-window-content">
        <div className="col-left">
          <AEPHistory />
        </div>

        <div className="col-right">
          <div className="col-right-content">
            <div className="chart">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart  data={[...chartData]} >
                  <CartesianGrid strokeDasharray="3 3"/>
                  <XAxis dataKey="year"/>
                  <YAxis yAxisId="left" tickFormatter={val => IndicatorsPool.roundValue(val, 2)} />
                  <YAxis yAxisId="right"  orientation="right" />

                  <Tooltip separator={Translations.chartSeparator} content={generateTtipContent} />


                  <Legend />

                  {visibleInds.map((id, i) => {
                    return (
                    <Line
                    key={id}
                    yAxisId="left"
                    name={indsTitles[id]}
                    dataKey={id}
                    stroke={COLORS[i]}
                    strokeWidth="1"
                    dot={customDot}

                    activeDot={{r: 8}}/>)
                  })}

                </LineChart>
              </ResponsiveContainer>
            </div>

            <div className="indicators">
              <IndicatorsGroupsList visibleInds={visibleInds} onClick={setIndicatorsChartVisibility} />
            </div>
          </div>

        </div>
      </div>
    </div>
  </>)
}


export default ReportPopup